import { render, staticRenderFns } from "./ClassGoals.vue?vue&type=template&id=ca0ca774&scoped=true&"
import script from "./ClassGoals.vue?vue&type=script&lang=js&"
export * from "./ClassGoals.vue?vue&type=script&lang=js&"
import style0 from "./ClassGoals.vue?vue&type=style&index=0&id=ca0ca774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ca774",
  null
  
)

export default component.exports